<template>
    <v-container fluid>
        <v-row>
            <!-- Back Button -->
            <v-col cols="1" v-if="mode !== 'GeneralLedger'">
                <v-btn-icon size="small" @click="$router.go(-1)" icon="$oss-chevron-left">
                </v-btn-icon>
            </v-col>
            <v-col cols="10">
                <h1>Z de caisse du {{ date }} - {{ period }}</h1>
            </v-col>
        </v-row>

        <!-- TVA Section -->
        <v-row justify="center" class="mt-2">
            <v-col cols="12" sm="10">
                <h5 class="title">Recettes encaissées</h5>
            </v-col>
            <v-col cols="12" sm="10">
                <v-card class="default_card large">
                    <v-data-table
                        :headers="headers"
                        :items="incomes"
                        class="table"
                        hide-default-footer
                    >
                        <!-- Table Rows -->
                        <template v-slot:item="props">
                            <tr>
                                <td class="text-left">
                                    <b>{{
                                        props.item.accountableAccount
                                            ? props.item.accountableAccount.description ||
                                              props.item.accountableAccount.name
                                            : "-"
                                    }}</b>
                                </td>
                                <td class="text-center">
                                    <b>{{
                                        props.item.vatRate !== undefined
                                            ? props.item.vatRate + "%"
                                            : "-"
                                    }}</b>
                                </td>
                                <td class="text-center">
                                    {{
                                        props.item.netAmount
                                            ? newCommonFormatCurrency(
                                                  props.item.netAmount,
                                                  undefined,
                                              )
                                            : ""
                                    }}
                                </td>
                                <td class="text-center">
                                    {{
                                        props.item.vatAmount
                                            ? newCommonFormatCurrency(
                                                  props.item.vatAmount,
                                                  undefined,
                                              )
                                            : ""
                                    }}
                                </td>
                                <td class="text-center">
                                    {{
                                        props.item.grossAmount
                                            ? newCommonFormatCurrency(
                                                  props.item.grossAmount,
                                                  undefined,
                                              )
                                            : ""
                                    }}
                                </td>
                                <td class="text-center">
                                    {{
                                        props.item.freeAmount
                                            ? newCommonFormatCurrency(
                                                  props.item.freeAmount,
                                                  undefined,
                                              )
                                            : ""
                                    }}
                                </td>
                            </tr>
                        </template>

                        <!-- Totals and Additional Rows -->
                        <template v-slot:body.append>
                            <tr>
                                <td />
                                <td class="text-right">
                                    <strong>Totaux</strong>
                                </td>
                                <td class="text-center">
                                    <strong>{{
                                        newCommonFormatCurrency(totalNetAmount, undefined)
                                    }}</strong>
                                </td>
                                <td class="text-center">
                                    <strong>{{
                                        newCommonFormatCurrency(totalVatAmount, undefined)
                                    }}</strong>
                                </td>
                                <td class="text-center">
                                    <strong>{{
                                        newCommonFormatCurrency(totalGrossAmount, undefined)
                                    }}</strong>
                                </td>
                                <td />
                            </tr>
                            <tr>
                                <td class="text-right" colspan="4">
                                    <strong>Dont montant offert</strong>
                                </td>
                                <td class="text-center">
                                    {{ newCommonFormatCurrency(freeAmount, undefined) }}
                                </td>
                                <td />
                            </tr>
                            <tr>
                                <td class="text-right" colspan="4">
                                    <strong>Montant payé</strong>
                                </td>
                                <td class="text-center">
                                    {{ newCommonFormatCurrency(paidAmount, undefined) }}
                                </td>
                                <td />
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import { TicketZBase } from "./TicketZBase";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

interface tHeader {
    title: string;
    value: string;
    sortable: boolean;
    align: "start" | "center" | "end";
}

@Component
export class TicketZPage extends TicketZBase {
    @Prop({ default: "" }) documentId: any;

    date: string = "";

    /* --- TVA --- */
    headers: tHeader[] = [
        {
            title: "Type de recette",
            value: "accountableAccount",
            sortable: false,
            align: "start",
        },
        { title: "TVA(%)", value: "vatRate", sortable: false, align: "center" },
        { title: "HT", value: "netAmount", sortable: false, align: "center" },
        { title: "TVA", value: "vatAmount", sortable: false, align: "center" },
        { title: "TTC", value: "grossAmount", sortable: false, align: "center" },
        { title: "Dont offert", value: "freeAmount", sortable: false, align: "center" },
    ];

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    async beforeMount() {
        if (this.inZTillReceipt) {
            this.date = moment(this.inZTillReceipt.date).locale("fr").format("DD MMM YYYY"); // set Day

            // set Period

            this.period = this.getPeriod(this.inZTillReceipt.period);
            this.date = this.getDate(this.inZTillReceipt);

            /* -- Transactions -- */

            console.log(this.documentId + "++++");

            if (this.inZTillReceipt.document) {
                // this.loadIncomes();
            } else {
                // obsolete migration accountingItem
                for (const document of this.inZTillReceipt.documents) {
                    let selected = false;
                    if (document.id === this.documentId) {
                        selected = true;
                    }
                    if (
                        document.accountableAccount &&
                        document.accountableAccount.name === this.freeAmountAccountableAccount
                    ) {
                        this.incomes.push({
                            accountableAccount: document.accountableAccount,
                            vatRate: document.vatRate,
                            netAmount: 0.0,
                            vatAmount: 0.0,
                            grossAmount: 0.0,
                            freeAmount:
                                Math.round((document.netAmount + document.vatAmount) * 100) / 100,
                        });
                    } else if (document.accountableAccount) {
                        this.incomes.push({
                            accountableAccount: document.accountableAccount,
                            vatRate: document.vatRate,
                            netAmount: document.netAmount,
                            vatAmount: document.vatAmount,
                            grossAmount: document.netAmount + document.vatAmount,
                            freeAmount: document.freeAmount || 0.0,
                        });
                    }
                }
            }
        }
    }
}

export default toNative(TicketZPage);
</script>
